module.exports = __webpack_public_path__ + "static/media/Select_force_change.af2df788.svg";